import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { processSteps } from '../mock';
import { CheckCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProcessSteps = () => {
  const [sectionContent, setSectionContent] = useState({
    title: 'Our Proven Process',
    subtitle: 'Simple, transparent steps to get your visa approved'
  });

  useEffect(() => {
    fetchSectionContent();
  }, []);

  const fetchSectionContent = async () => {
    try {
      const response = await axios.get(`${API}/page-content/home`);
      const processData = response.data.find(item => item.section_name === 'process');
      if (processData && processData.content) {
        setSectionContent(processData.content);
      }
    } catch (error) {
      console.error('Failed to fetch section content:', error);
    }
  };

  return (
    <section id="process" className="process-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">{sectionContent.title}</h2>
          <p className="body-large section-subtitle">
            {sectionContent.subtitle}
          </p>
        </div>

        <div className="process-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="process-card hover-lift">
              <div className="step-number mono-text">{step.step}</div>
              <div className="step-icon">
                <CheckCircle size={24} />
              </div>
              <h3 className="heading-3">{step.title}</h3>
              <p className="body-small">{step.description}</p>
              {index < processSteps.length - 1 && (
                <div className="step-connector"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;